const BOOKING_STEP_TITLES: Record<string, string> = {
  location: 'Location',
  time: 'Time',
  insurance: 'Insurance',
  partner: 'Partner Details',
  confirm: 'Confirmation'
};

export const getBookingStepTitle = (step?: string | null): string => {
  if (!step) return '';

  return (
    BOOKING_STEP_TITLES[step] ??
    step.replace(/_/g, ' ').replace(/\b\w/g, letter => letter.toUpperCase())
  );
};
